import { takeIfExists } from "./local-storage";

export const processContentSectionCheckboxes = (rootNode, progressData, programId, createOrUpdateCSItem, url) => {
  if (!rootNode) return;

  const allInputs = rootNode.querySelectorAll('input[type="checkbox"]');
  for (let input of allInputs) {
    const attr = input.getAttribute("data-attr");
    const id = input.getAttribute("id");
    const value = input.getAttribute("value");
    const parent = input.parentNode;
    const hasLabel = parent.querySelector("label") != null;
    if(!attr && !id && !value && !hasLabel) {
      input.setAttribute('checkbox', 'true');
      const inputContent = parent.innerHTML.split('checkbox="true">')[1]
      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      const label = document.createElement('label');
      label.innerHTML = inputContent;
      checkbox.setAttribute('id', inputContent);
      checkbox.checked = input.checked;
      checkbox.disabled = input.disabled;
      checkbox.setAttribute('tabindex', '0');
      label.setAttribute("for", inputContent);
      parent.setAttribute("class", 'md-checkbox');

      parent.textContent = '';
      parent.appendChild(checkbox);
      parent.appendChild(label);
    }
  }

  const inputsWithDataAttr = document.querySelectorAll("[data-attr]");
  for (let input of inputsWithDataAttr) {
    const attr = input.getAttribute("data-attr");
    const parent = input.parentNode;
    const href = url;
    const attrSubstr = attr.substring(0,512);

    const item = progressData.filter(e => !!e.programId ? e.programId === programId : true)
      .findLast((e) => {
        return href.startsWith(e.path) && e.attribute === attrSubstr
      });

    input.setAttribute('checkbox', 'true');
    const checkbox = document.createElement("input");
    checkbox.setAttribute('id', attr);
    checkbox.type = "checkbox";
    const label = document.createElement('label');
    label.setAttribute("for", attr);
    label.innerHTML = input.parentNode.innerHTML.split('checkbox="true">')[1];
    parent.setAttribute("class", 'md-checkbox');

    // Adding attributes for acessibility to checkmark and label;
    label.setAttribute("id", `id=${attr}`);
    checkbox.setAttribute('tabindex', '0');
    checkbox.setAttribute('aria-labelledby', `id=${attr}`);

    if (item) {
      const event = new Event('input', { bubbles: false })
      checkbox.checked = item.isChecked;
      checkbox.dispatchEvent(event);
    }

    if (checkbox.getAttribute('listener') !== 'true') {
      checkbox.onkeypress = function() {
        // Acessibility: force click event on enter key event;
        checkbox.click();
      }

      checkbox.addEventListener("change", function (event) {
        const value = event.currentTarget.getAttribute("id");
        createOrUpdateCSItem({
          isChecked: event.currentTarget.checked,
          attribute: value,
          path: url,
          programId: programId,
        })
      }, false)
    }
    checkbox.setAttribute('listener', 'true');
    parent.textContent = '';
    parent.appendChild(checkbox);
    parent.appendChild(label);
  }
}

export const calcNodeProgress = (node, communityPartnershipLink, userActivitiesInfo, isFacilitator, removeDuplicates) => {
  let progress = 0;

  if (node && node.activities && node.type === 'set') {
    const activitiesWithContentSections = node.activities.filter(r => r.contentSections && r.contentSections.length > 0)
      .map(a => communityPartnershipLink ? `${communityPartnershipLink}${node.path}/${a.slug}` : `/gwc${node.path}/${a.slug}`);
    const activitiesWithoutContentSections = node.activities.map(a => communityPartnershipLink ? `${communityPartnershipLink}${node.path}/${a.slug}` : `/gwc${node.path}/${a.slug}`)
      .filter(s => activitiesWithContentSections.indexOf(s) === -1);
    const allActivities = [...activitiesWithContentSections, ...activitiesWithoutContentSections];

    // user activities info within current set
    const uActivitiesIntersection = userActivitiesInfo.filter(uai => allActivities.indexOf(uai.path) !== -1);

    // done activities
    const done = uActivitiesIntersection.filter(r => r.isDone === true).map(r => r.path).filter(onlyUnique);
    // activities that are in progress excluding done
    let inProgress = uActivitiesIntersection.filter(r => !r.isDone && done.indexOf(r.path) === -1);

    // excluding inProgress userActivities that don't have contentSection field but activity does have content sections
    inProgress = inProgress.filter((r) => {
      const activity = node.activities.find(a => communityPartnershipLink ? `${communityPartnershipLink}${node.path}/${a.slug}` === r.path : `/gwc${node.path}/${a.slug}` === r.path);

      if (!activity.contentSections || activity.contentSections.length === 0) {
        return true;
      }

      return !!r.contentSection;
    }).map(r => r.path).filter(onlyUnique);

    // calculating progress
    progress = ((inProgress.length + done.length * 2) / (allActivities.length * 2)) * 100;
  } else if (node && node.nodeType && (node.nodeType === 'activity' || node.nodeType === 'set')) {
    const completedActivity = userActivitiesInfo.find(r => (communityPartnershipLink ? r.path === `${communityPartnershipLink}${node.path}` : r.path === `/gwc${node.path}`) && r.isDone);

    if (!!completedActivity) {
      progress = 100;
    } else if (!node.contentSections) {
      const isViewed = userActivitiesInfo.find(r => (r.path === `/path${node.slug}`));

      if (isViewed) {
        progress = 99;
      }
    } else {
      const contentSectionsViewed = userActivitiesInfo.filter(r => communityPartnershipLink ? r.path === `${communityPartnershipLink}${node.path}` : r.path === `/gwc${node.path}`).map(r => r.contentSection);
      const allContentSections = isFacilitator ? node.contentSections.map(r => r.id)
        : node.contentSections.filter(r => !r.onlyVisibleToFacilitators).map(r => r.id);

      const intersection = removeDuplicates(contentSectionsViewed.filter(c => allContentSections.includes(c)));

      progress = (intersection.length / allContentSections.length) * 100;

      if (progress === 100) {
        progress = 99;
      }
    }
  }
  return progress;
};

export const onlyUnique = (value, index, self) => self.indexOf(value) === index;

export const getRouteInfo = (path, nodes, parentNode) => {
  const plainNodes = Object.values(nodes);
  const current = plainNodes.find((e) => e.slug === path);
  const currentIndex = plainNodes.indexOf(current);
  const isLast = currentIndex + 1 === plainNodes.length;
  const nextItem = isLast ? null : plainNodes[currentIndex + 1];
  return { plainNodes, current, parentNode, path, isLast, nextItem };
};

export const getNextItem = (curriculum, currentNode, parts) => {
  if (!curriculum || !currentNode || !parts) {
    return;
  }
  let current = curriculum;
  let nodeArray = [];
  for (var p of parts) {
    const node = getRouteInfo(p, current.nodes, current);
    current = node.current;
    nodeArray.push(node);
  }
  nodeArray = nodeArray.reverse();
  const parentNode = nodeArray.find((e) => !e.isLast);

  if (parentNode) {
    const { nextItem } = parentNode;
    return nextItem;
    // getDeepActivity(nextItem); -- temporary disabled due toHQ-2457
  } else {
    return nodeArray[nodeArray.length - 1].current;
  }
};

export const getCurrentNode = (curriculum, path) => {
  let next = null;
  let previous = null;

  if (!curriculum) return { current: null, next, previous };

  const parts = path
    .replace("/gwc", "")
    .split("/")
    .filter((p) => p.length > 0);

  let current = curriculum;
  let parentNode = null;

  const chain = [];

  for (const p of parts) {
    if (!current) {
      continue;
    }

    const plainNodes = Object.values(current.nodes);
    for (let i = 0; i < plainNodes.length; i++) {
      const n = plainNodes[i];

      if (n.slug === p) {
        chain.push(n);

        if (i !== 0) {
          previous = plainNodes[i - 1];
        } else {
          previous = null;
        }

        next = getNextItem(curriculum, current, parts);
      }
    }

    parentNode = {
      ...current,
    };
    current = current.nodes[p];
  }

  return {
    chain,
    current,
    next,
    parentNode,
    previous,
    parts,
  };
};

export const getStudentsSections = (activity) => {
  if (!activity || !activity.contentSections) {
    return null;
  }

  const items = activity.contentSections.filter(
    (item) => !item.onlyVisibleToFacilitators
  );
  return items.length > 0 ? items : null;
};

export const onIdeActivitySetClick = (item, step, programId) => {
  const ideActivitySetData = takeIfExists("ideActivitySetData", Object);

  if (ideActivitySetData) {
    localStorage.removeItem('ideActivitySetData');
  }
  localStorage.setItem("ideActivitySetData", JSON.stringify({
    activitySetId: item.id,
    activitySetName: item.name,
    programId,
    step,
    path: item.path,
    ideProjectStarterCodeId: item.ideProjectStarterCode?.id,
  }));
}
